import React, { useEffect } from 'react';
import {Route} from "react-router-dom";
import useUserInfo from "../../hooks/useUserInfo";
import Unauthorized from "../../components/Notice/Unauthorized";

const AuthorizedRoute = ({path, component, permission}) => {
  const {permissions} = useUserInfo();

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[])

  // point to unauthorized component if user lacks permission
  if (!permissions.includes(permission))
    component = Unauthorized;

  return <Route path={path} component={component}/>
};

export default AuthorizedRoute;


// WEBPACK FOOTER //
// ./src/routes/routeTypes/AuthorizedRoute.js